const HourglassIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 4.75C6 4.33437 6.33437 4 6.75 4H17.25C17.6656 4 18 4.33437 18 4.75C18 5.16562 17.6656 5.5 17.25 5.5H17V6.09375C17 7.35313 16.5 8.5625 15.6094 9.45312L13.0594 12L15.6062 14.5469C16.5 15.4375 17 16.6469 17 17.9062V18.5H17.25C17.6656 18.5 18 18.8344 18 19.25C18 19.6656 17.6656 20 17.25 20H6.75C6.33437 20 6 19.6656 6 19.25C6 18.8344 6.33437 18.5 6.75 18.5H7V17.9062C7 16.6469 7.5 15.4375 8.39062 14.5469L10.9406 12L8.39062 9.45312C7.5 8.5625 7 7.35313 7 6.09375V5.5H6.75C6.33437 5.5 6 5.16562 6 4.75ZM9.45312 15.6094C9.33125 15.7312 9.21875 15.8625 9.11875 16H14.8813C14.7812 15.8625 14.6687 15.7312 14.5469 15.6094L12 13.0594L9.45312 15.6062V15.6094ZM14.8813 8C15.2812 7.45 15.5 6.78125 15.5 6.09375V5.5H8.5V6.09375C8.5 6.78437 8.71875 7.45 9.11875 8H14.8813Z"
      fill="#58348E"
    />
  </svg>
);

export default HourglassIcon;
